export default "__VITE_ASSET__b662e5d3__"